const internships = {
  title: "Internship Experience",
  experiences: [
    {
      company: "AGRI TECH CMSD",
      role: "App Developer",
      duration: "Nov 2023 – Jan 2024",
      location: "Kundrathur, Tamil Nadu, India",
      description: [
        "Spearheaded frontend and UI development using Flutter, ensuring responsive design across devices.",
        "Crafted visually engaging and user-centric interfaces to improve overall app usability.",
        "Collaborated with cross-functional teams to implement seamless navigation and intuitive layouts.",
        "Delivered a polished, high-performance application interface, boosting user engagement by 30%.",
        "Gained hands-on experience in real-world app development, strengthening Flutter and UI design skills."
      ]
    },
    {
      company: "DiAtom Technologies",
      role: "App Developer",
      duration: "Feb 2024 – Apr 2024",
      location: "Kundrathur, Tamil Nadu, India",
      description: [
        "Enhanced a responsive cross-platform website using HTML, CSS, and JavaScript.",
        "Engineered a scalable mobile application using Flutter and Firebase.",
        "Implemented backend integration and real-time data handling for dynamic features.",
        "Designed promotional posters using Canva to improve brand visibility.",
        "Developed skills across web development, mobile apps, and design."
      ]
    },
    {
      company: "Prodapt Solutions Private Limited",
      role: "Trainee",
      duration: "July 2026 – Present",
      location: "Perungudi, Tamil Nadu, India",
      description: []
    }
  ]
};

export default internships;